module.exports = __webpack_public_path__ + "img/13.ed1c65a2.svg";